export const translations = {
  aboutyou: 'About you',
  hearingtest: 'Hearing test',
  results: 'Results',
  welcome: 'Welcome to the Jabra online hearing test',
  knowmore: 'Grab your headphones and find a quiet space. ',
  grabheadphones: 'The test works with all headphone types, and takes less than five minutes.',
  disclaimer: 'Understanding the results of this test',
  disclaimer1:
    "The Jabra online hearing test isn't a substitute for a visit to a hearing care professional, and it doesn't constitute a medical diagnosis.",
  disclaimer2:
    "If you think you're experiencing hearing loss, we advise you to consult a hearing care professional for a more comprehensive examination.",
  disclaimer3:
    'When you click the button below you give us your consent to use the information provided by you in the test, to carry out the test and show you the result of the test. You are free to withdraw your consent at any time. See more in our <a href="/footerpages/disclaimer">privacy policy</a>. ',
  disclaimerresults:
    "Remember, this test isn't a substitute for a medical exam and these results are not a medical diagnosis.",
  starttest: 'Start test',
  gender: 'Sex',
  male: 'Male',
  female: 'Female',
  prefernottosay: 'Prefer not to say',
  yearbirth: 'Year of birth',
  describehearing: 'How would you describe your hearing?',
  verypoor: 'Very poor',
  poor: 'Poor',
  good: 'Good',
  verygood: 'Very good',
  prevpage: 'Previous',
  nextpage: 'Next',
  whenproblemshearing: 'When do you have the most difficulty hearing?',
  socialgatherings: 'Social gatherings',
  restaurants: 'Restaurants',
  noisyenvironments: 'Noisy environments',
  meetingswork: 'Meetings at work',
  television: 'Watching TV',
  onphone: 'On the phone',
  idontknow: "I don't know",
  ls2headline: 'Just before the test starts, we are curious about your opinion',
  ls2description:
    '3 quick questions regarding what matters most to you and how you envision yourself using a hearing enhancing product if you were to use or try one.',
  appreciateproductdesign: 'Product design is important to me, and I care how it looks on me',
  stronglydisagree: 'Strongly disagree',
  disagree: 'Disagree',
  agree: 'Agree',
  stronglyagree: 'Strongly agree',
  calculatingResults: 'Calculating your results...',
  comfortisimportant: 'It is important to me that I am comfortable while wearing it',
  wearaproduct: 'If I were to wear a product, I would like to wear it',
  situationineed: 'In the situations I need it',
  whenconventient: "When it's convenient for me",
  allday: 'All-day',
  headphoneson: 'Find a quite place and put on your headphones.',
  bgnoises:
    'Background noises like air conditioning, fridges, and street traffic can interfere with the test.',
  soundcheck: 'Sound check',
  soundcheckdesc:
    "Before we begin the hearing test, let's make sure your audio is working correctly.",
  setyourdevicemax: 'Set your device to its maximum volume',
  testheadphones: 'Test that your headphones are working properly',
  playsong: 'Play song',
  stopsong: 'Stop playing',
  keepvolume: 'Keep your device at full volume for the entire test',
  nowfortest: 'Now for the test',
  startleftear: "Let's start with your left ear",
  maxvolheadphoneson: 'MAXIMUM VOLUME. HEADPHONES ON.',
  '500hzl': '500 Hz — <span>Left ear</span>',
  clicknumbers:
    'Starting at #1, click each number until you can <strong>just barely hear the tone.</strong>',
  start: 'START',
  heartone: "Can't hear the tone?",
  heartone2: 'Click the next number.',
  barelyhear: 'Just barely hear it?',
  clicksave: 'Click Save and continue',
  savenadcontinue: 'Save and continue',
  '1000hzl': '1000 Hz — <span>Left ear</span>',
  '2000hzl': '2000 Hz — <span>Left ear</span>',
  '4000hzl': '4000 Hz — <span>Left ear</span>',
  rightearintro: "Excellent! You're done with the left ear",
  moveontorightear: "Let's move on to the right ear",
  '500hzr': '500 Hz — <span>Right ear</span>',
  '1000hzr': '1000 Hz — <span>Right ear</span>',
  '2000hzr': '2000 Hz — <span>Right ear</span>',
  '4000hzr': '4000 Hz — <span>Right ear</span>',
  resultheadlinegood: 'The score indicate that you have good hearing ',
  resultheadlinehearingloss: 'Your results suggest you may have hearing loss',
  resultsignificantloss: 'Significant loss',
  resultloss: 'Loss',
  resultgood: 'Good',
  leftear: 'Left ear',
  rightear: 'Right ear',
  resultgooddesc: 'Indication of good hearing.',
  resultmoderatedesc: 'Indication of hearing loss.',
  resultseveredesc: 'Indication of high levels of hearing loss.',
  recommendedProducts: 'Recommended Products',
  jabraenhanceplus: 'Jabra Enhance Plus',
  plusksp1: 'Hearing enhancement solution with medical-grade technology',
  plusksp2: 'Situational use',
  plusksp3: 'Improves speech clarity',
  plusksp4: 'Discreet and comfortable',
  plusksp5: 'Music, streaming and calls',
  plusksp6: 'Up to 12 hours of battery per charge',
  plusksp7: 'Set-up and personalization via the app',
  learnmore: 'Learn more',
  jabraenhancepropm: 'Jabra Enhance Pro PM',
  propmksp1: 'Premium medical-grade hearing solution for all-day use',
  propmksp2: 'Excellent speech clarity and hearing in noisy environments',
  propmksp3: 'Durable, discreet design',
  propmksp4: 'Direct streaming from compatible iOS® and Android™ devices',
  restarttest: 'Restart test',
  retakeaudiotest: 'Retake audio test',
  buynow: 'Buy now',
  donotforgetvolume: "Don't forget to reduce the volume on your device",
  instructions: 'Instructions:',
  setupinstructions: 'Setup Instructions:',
  instructions1: 'Put on your headphones or earbuds',
  instructions2: 'Adjust your device volume to a comfortable level',
  instructions3: 'Click the "Test Sound" button to verify audio is working',
  instructions4: 'You should hear a clear tone from both ears',
  instructions5: 'If you cannot hear the sound, check your audio device connection',
  audiotest: 'Audio Test',
  testsound: 'Test Sound',
  stopsound: 'Stop Sound',
  loading: 'Loading...',
  audiotestsuccessful: 'Audio test successful!',
  successfuldesc:
    'Great! Your audio is working correctly. You can now proceed to the hearing test.',
  audioworkingcorrectly:
    'Great! Your audio is working correctly. You can now proceed to the hearing test.',
  audioerror: 'Audio Error:',
  troubleshooting: "Can't hear the sound?",
  troubleshooting1: 'Check that your headphones or earbuds are properly connected',
  troubleshooting2: 'Increase your device volume',
  troubleshooting3: 'Make sure no other applications are using your audio',
  troubleshooting4: "Try refreshing the page if the audio isn't loading",
  continuetohearingtest: 'Continue to Hearing Test',
  loadingaudiotestfile: 'Loading audio test file...',
  stepof: 'Step {current} of {total}',
  moveslider: 'Move the slider to describe your hearing',
  environmentshelp: 'Please select at least one option',
  designimportancehelp: 'Please move the slider to choose a rating',
  comfortimportancehelp: 'Please move the slider to choose a rating',
  wearingsituationhelp: 'Please select one option',
  volumehelp: 'Please select a volume before continuing',
  required: 'Required',
  verypoorhelp: 'I have significant hearing difficulties',
  poorhelp: 'I have difficulty hearing in some situations',
  goodhelp: 'I hear well in most situations',
  verygoodhelp: 'I hear everything clearly',
  genderhelp: 'Please select your gender',
  yearbirthhelp: 'Please enter your year of birth (e.g., 1990)',
  wearproduct: 'How often would you wear your hearing aids?',
  onlywhenneed: 'Only when needed',
  onlywhenneedhelp: 'In specific situations where I need better hearing',
  whenconvenient: 'When convenient',
  whenconvenienthelp: 'When it suits my schedule and activities',
  mostofthetime: 'Most of the time',
  mostofthetimehelp: 'Throughout the day with occasional breaks',
  alldaylong: 'All day long',
  alldayhelp: 'From morning until evening every day',
  arrowpointingstart: 'Arrow pointing down to start button',
  soundwaveillustration: 'Sound wave illustration',
  volumelevel: 'Volume level {level}',
} as const;

export type TranslationKey = keyof typeof translations;
